import React__default, { useRef } from 'react';
import classnames from 'classnames';
import Controls from '../Controls/index.js';
import TextArea from 'react-autosize-textarea';
import ExpandFlatIcon from './expand-flat.svg.js';
import DetachIcon from './detach.svg.js';
import styles from './styles.css.js';

var Composer = function Composer(_a) {
  var collapsed = _a.collapsed,
      controls = _a.controls,
      attachments = _a.attachments,
      setComposerRef = _a.setComposerRef,
      onFocus = _a.onFocus,
      onAppendText = _a.onAppendText,
      onAttach = _a.onAttach,
      onDetach = _a.onDetach,
      onChange = _a.onChange,
      onExpand = _a.onExpand,
      onSubmit = _a.onSubmit,
      text = _a.text,
      loading = _a.loading,
      conversationId = _a.conversationId;
  var button = useRef(null);

  var handleKeyPress = function handleKeyPress(event) {
    // Submit the form on "Enter", unless it was "Shift+Enter"
    // React fires a synthetic event for form submissions, so we click the submit button to trigger the event
    if (event.key === 'Enter' && !event.shiftKey && button.current) {
      button.current.click();
      event.preventDefault();
    }
  };

  return React__default.createElement("form", {
    className: classnames(styles.composer, styles.flat),
    onSubmit: onSubmit
  }, attachments && attachments.length > 0 && React__default.createElement("div", {
    className: styles.preview
  }, attachments.map(function (attachment, index) {
    var PreviewComponent = attachment.previewer;
    return React__default.createElement("div", {
      key: index,
      className: styles.attachment
    }, React__default.createElement("div", {
      className: styles.detach,
      onClick: function onClick() {
        return onDetach(index);
      }
    }, React__default.createElement(DetachIcon, {
      className: styles.detachIcon
    })), React__default.createElement(PreviewComponent, {
      data: attachment.data
    }));
  })), React__default.createElement("div", {
    className: styles.tray
  }, React__default.createElement("div", {
    className: styles.textAreaWrapper
  }, React__default.createElement(TextArea, {
    innerRef: setComposerRef,
    className: styles.input,
    onFocus: onFocus,
    value: text || '',
    placeholder: "Send a message...",
    onChange: onChange,
    onKeyPress: handleKeyPress,
    disabled: loading
  })), !collapsed && React__default.createElement(Controls, {
    conversationId: conversationId,
    controls: controls || [],
    onAttach: onAttach,
    onAppendText: onAppendText,
    collapsed: collapsed,
    onError: console.log
  }), collapsed && controls && controls.length ? React__default.createElement("div", {
    className: styles.expand,
    onClick: onExpand
  }, React__default.createElement(ExpandFlatIcon, {
    className: styles.expandIcon
  })) : null, React__default.createElement("button", {
    type: "submit",
    className: !loading ? styles.send : styles.disabled,
    ref: button
  }, "Send")));
};

export default Composer;
//# sourceMappingURL=index.js.map
